import { AlertTriangle, Check, File, Trash2 } from "@tamagui/lucide-icons";
import { XStack, YStack } from "tamagui";

import type { AttachmentType } from "@/api/mutations/conversation";
import { Button, LoadingSpinner, Paragraph } from "@/components";

export default function PhotoUploadSummary({
  attachments,
  onRemove,
}: {
  attachments: AttachmentType[];
  onRemove: (localUri: string) => void;
}) {
  if (attachments.length === 0) return null;
  return (
    <YStack marginTop="$250" paddingHorizontal="$150" gap="$250">
      {attachments.map((attachment) => {
        const uploaded = !!attachment.attachmentId;
        const errored = !!attachment.error;
        const name = attachment.name ?? "Attachment";
        return (
          <XStack key={attachment.localUri} alignItems="center" gap="$100">
            <File size="$300" color={"$iconBase"} flexShrink={0} />
            <YStack flex={1} gap="$25">
              <Paragraph numberOfLines={1} color={errored ? "$red" : undefined}>
                {name}
              </Paragraph>
              {errored && (
                <Paragraph size="$xs" color="$red">
                  {attachment.error}
                </Paragraph>
              )}
            </YStack>
            {errored ? (
              <AlertTriangle size="$300" color="$red" />
            ) : uploaded ? (
              <Check size="$300" color="$green" />
            ) : (
              <LoadingSpinner size="$300" />
            )}
            <Button.Wrapper
              aria-label={"Remove attachment"}
              onPress={() => onRemove(attachment.localUri)}
            >
              <Trash2 size="$300" color="$iconBase" />
            </Button.Wrapper>
          </XStack>
        );
      })}
    </YStack>
  );
}
